import React from 'react';
import { style } from 'typestyle';
import { ADALONG_COLORS } from '@src/styles';
import { Loader } from '@src/components/Loader';

export function MessagesScroller(props: {
  items: JSX.Element[];
  isLoading: boolean;
}) {
  return (
    <div className={containerClass}>
      {props.isLoading ? (
        <div className={loadingContainerClass}>
          <Loader size={30} />
          <span>Loading messages...</span>
        </div>
      ) : props.items.length === 0 ? (
        <div className={emptyStateClass}>
          No messages
        </div>
      ) : null}
      {props.items}
    </div>
  );
}

const containerClass = style({
  width: '100%',
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
});

const loadingContainerClass = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '200px',
  gap: '16px',
  color: 'white',
});

const emptyStateClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '200px',
  color: ADALONG_COLORS.LIGHT_GRAY,
  fontSize: '16px',
});
